import { Datetime } from '@/utils/dates';
import { zeroPadFlightNumber } from '@/utils/numbers';

export const formatTripTitle = (servicerIataAirlineCode: string, flightNumber: number, scheduled: string): string =>
  `${(servicerIataAirlineCode || '').toUpperCase()}${zeroPadFlightNumber(flightNumber)} ${
    scheduled ? new Datetime(scheduled).frontendDatetimeShort : ''
  }`;
export const isUpcomingTrip = (utcDatetime: Datetime): boolean =>
  utcDatetime.isSameUtc(undefined, 'day') && utcDatetime.diffUtc(undefined, 'hour') < 1;
